import { useViewport } from '@chilecompra/react-kit'
import { Button, Toast } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { Container } from '../Cfmp.styles'

/**
 * The CfmpActions component.
 */
export const CfmpActions = ({ isDisabled = false, onBack, onSubmit, submit }) => {
  const { size } = useViewport()

  const { error, loading: submitLoading } = submit
  const hasSubmitError = Boolean(error)

  return (
    <Container direction="column" padding="32px 0 0" spacing={4}>
      {hasSubmitError && (
        <Toast
          border
          severity="error"
          textDirection="vertical"
          title="Lo sentimos, estamos presentando problemas con nuestro servidor."
        >
          En estos momentos tenemos problemas para disponibilizar la información. Por favor,
          consulta en unos minutos más.
        </Toast>
      )}

      <Container
        alignItems="center"
        direction={size.isTiny ? 'column' : 'row'}
        justifyContent={size.isTiny ? 'center' : 'space-between'}
        spacing={2}
      >
        <Button
          color="primary"
          disabled={isDisabled}
          onClick={onBack}
          padding="0 16px"
          variant="outlined"
          width={size.isTiny ? '100%' : '200px'}
        >
          Volver
        </Button>

        <Button
          color={hasSubmitError ? 'error' : 'primary'}
          disabled={isDisabled}
          loading={submitLoading}
          onClick={onSubmit}
          padding="0 16px"
          variant={hasSubmitError ? 'outlined' : 'contained'}
          width={size.isTiny ? '100%' : '200px'}
        >
          {hasSubmitError ? 'Reintentar' : 'Enviar'}
        </Button>
      </Container>
    </Container>
  )
}

CfmpActions.propTypes = {
  isDisabled: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submit: PropTypes.object.isRequired
}
